import styled from 'styled-components'

export const Wrapper = styled.div`
  > .rankmiTable-container {
    margin-top: -20px;
  }
  > .rankmiTable-container > div {
    display: none;
  }
  > .rankmiTable-container > div + div {
    display: initial;
  }
`

export const Options = styled.div`
  button {
    float: right;
    padding: 0 8px;
    color: #4c4c4c !important;
    border-radius: 8px;
    background-color: #f0f0f0 !important;
    margin-left: 8px;
    svg {
      transition: 200ms;
    }
    &:hover > svg {
      opacity: 0.5;
    }
  }
`

export const AddCourse = styled.div`
  button {
    color: #2684ff;
    height: 40px;
    margin-top: 8px;
    font-weight: 700;
    svg {
      margin-right: 8px;
    }
  }
`
